<template>
  <small-modal
    :fit-content="true"
    :show-close-button="false"
    class="localization-bulk-filter-modal"
    @close="$emit('close-filter-modal')"
  >
    <div class="campaign-filter-container">
      <h1 class="filter">{{ $t("campaignManager.filter.filters") }}</h1>
      <span class="reset" @click="resetFilters">{{
        $t("campaignManager.filter.reset")
      }}</span>
      <form class="filter-wrapper">
        <div class="filter-block">
          <label>
            <h2 class="filter-type-title">
              {{ $t("productPages.filters.languages") }}
            </h2>
          </label>
          <v-select
            :value="selectedLanguages"
            class="dropdown scrollable-dropdown"
            :options="languagesOptions"
            label="language"
            :reduce="(opt) => opt.language"
            :searchable="true"
            multiple
            :placeholder="placeholder"
            @input="(val) => $emit('filter', { languages: val })"
          />
        </div>
        <div class="filter-block">
          <label>
            <h2 class="filter-type-title">Tags</h2>
          </label>
          <v-select
            :value="selectedTags"
            class="dropdown tags-dropdown"
            :options="tagsOptions"
            label="name"
            multiple
            :placeholder="placeholder"
            @input="(val) => $emit('filter', { tags: val })"
          />
        </div>
      </form>
    </div>
  </small-modal>
</template>

<script>
import SmallModal from "@/components/shared/SmallModal.vue";

export default {
  components: {
    SmallModal,
  },
  props: {
    languagesOptions: {
      type: Array,
      required: true,
    },
    selectedLanguages: {
      type: Array,
      required: true,
    },
    tagsOptions: {
      type: Array,
      default: () => [],
    },
    selectedTags: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      placeholder: this.$t("campaignManager.filter.select"),
    };
  },
  methods: {
    resetFilters() {
      this.$emit("filter", {
        languages: [],
      });
      this.$emit("reset");
    },
  },
};
</script>

<style lang="scss">
.localization-bulk-filter-modal .small-modal.fit-modal {
  box-shadow: 0px 0px 6px 1px rgba(0, 0, 0, 0.25);
  padding: 16px;
  top: 145px;
  right: 62px;
  left: auto;
  transform: none;
  width: 210px;
}
.dropdown {
  .vs__dropdown-toggle {
    min-height: 48px;
  }
  .vs__search {
    font-family: Montserrat;
    color: $light-grey;
    font-size: 14px;
    font-weight: 400;
  }
  .vs__selected-options {
    flex-wrap: wrap !important;
  }
  .vs__dropdown-option {
    padding-left: 8px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .vs__dropdown-menu {
    position: absolute !important;
  }

  .vs__dropdown-menu {
    min-height: 30px !important;
    max-height: 200px !important;
    overflow: auto !important;
    flex-wrap: wrap;
  }
}

.scrollable-dropdown {
  .vs__dropdown-menu {
    min-height: 30px !important;
    max-height: 200px !important;
    overflow: auto !important;
    flex-wrap: wrap;
  }
}
.v-select.dropdown.scrollable-dropdown.vs--multiple.vs--searchable.vs__dropdown-toggle {
  height: auto !important;
}
</style>

<style lang="scss" scoped>
.modal-background {
  background: transparent;
}

.filter {
  font-size: 14px;
  font-weight: 700;
  line-height: 17px;
  cursor: default;
  margin-bottom: 14px;
}
.reset {
  font-size: 10px;
  font-weight: 400;
  line-height: 12px;
  color: $light-grey;
  position: fixed;
  top: 16px;
  right: 16px;
  cursor: pointer;
}

.filter-wrapper {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.filter-type-title {
  margin-bottom: 8px;
}
</style>
